"use strict";

exports.__esModule = true;
exports.textTheme = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var textTheme = function textTheme(baseTheme) {
  return _objectSpread({
    Text_color: baseTheme.color,
    Text_color_h1: baseTheme.h1_color,
    Text_color_h2: baseTheme.h2_color,
    Text_color_h3: baseTheme.h3_color,
    Text_color_h4: baseTheme.h4_color,
    Text_color_h5: baseTheme.h5_color,
    Text_color_h6: baseTheme.h6_color,
    Text_color_mouse: baseTheme.color_mouse,
    Text_fontSize: baseTheme.fontSize_ui,
    Text_fontSize_h1: baseTheme.h1_fontSize,
    Text_fontSize_h2: baseTheme.h2_fontSize,
    Text_fontSize_h3: baseTheme.h3_fontSize,
    Text_fontSize_h4: baseTheme.h4_fontSize,
    Text_fontSize_h5: baseTheme.h5_fontSize,
    Text_fontSize_h6: baseTheme.h6_fontSize,
    Text_fontSize_mouse: baseTheme.fontSize_mouse,
    Text_fontSize_prose: baseTheme.fontSize_prose,
    Text_fontWeight_h1: baseTheme.h1_fontWeight,
    Text_fontWeight_h2: baseTheme.h2_fontWeight,
    Text_fontWeight_h3: baseTheme.h3_fontWeight,
    Text_fontWeight_h4: baseTheme.h4_fontWeight,
    Text_fontWeight_h5: baseTheme.h5_fontWeight,
    Text_fontWeight_h6: baseTheme.h6_fontWeight,
    Text_lineHeight: baseTheme.lineHeight_prose,
    Text_lineHeight_heading: baseTheme.lineHeight_heading,
    Text_lineHeight_headingSmall: baseTheme.lineHeight_headingSmall,
    Text_marginBottom: baseTheme.space_stack_md,
    Text_marginBottom_heading: baseTheme.space_stack_sm
  }, baseTheme);
};

exports.textTheme = textTheme;